import React from "react";
import Modal from "react-modal";
import HoverModalHeader from "./HoverModalHeader";
import { customModalStyles } from "../../../../_shared/components/Modal/ModalStyles";
import HoverModalContent from "./HoverModalContent";
import "./HoverModal.scss";

// Modal.setAppElement("#root");
function HoverModal(props) {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [handler, setHandler] = React.useState("");

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    //Prevents scrolling for subscriptions page when remove-tickers-modal is active.
    if (modalIsOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "scroll";
  }, [modalIsOpen]);

  React.useEffect(() => {
    try {
      props.setDisableDeleteContextMenu(modalIsOpen && true);
    } catch (err) {
      console.log(err);
    }
  }, [modalIsOpen]);

  function clickModal() {
    setIsOpen(!modalIsOpen);
  }

  return (
    <div>
      <div
        className="kiss-view-ticker-target"
        style={{ cursor: "pointer" }}
        onClick={() => setIsOpen(true)}
      >
        {props.cell.column?.Header !== "Description"
          ? props.cell.value?.split(" ")[0]
          : props.cell.value}
      </div>
      {modalIsOpen && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={clickModal}
          style={customModalStyles}
          contentLabel="Ticker Modal"
        >
          <div style={{ position: "relative", top: 0 }}>
            {/* KISS View Ticker Modal Top Section */}
            {/* Includes Last Price, Core Signal, Trading Range, Odds and Beta Sections. */}
            <HoverModalHeader
              cell={props.cell}
              split={props.split}
              ratio={props.ratio}
              beforeSplit={props.beforeSplit}
              afterSplit={props.afterSplit}
              clickModal={clickModal}
              planInterval={props.planInterval}
              closingDate={props.closingDate}
              updatedDate={props.updatedDate}
            />
            {/* KISS View Ticker Modal Bottom Section */}
            {/* Includes Longbow Core Signal, Signal Odds, Range Signal, and Short Term and Medium Term Signal Pills. */}
            <HoverModalContent cell={props.cell} />
          </div>
        </Modal>
      )}
      {/* <TickerContextMenu showMenu={contextMenu} deleteTicker={deleteTicker} /> */}
    </div>
  );
}
export default React.memo(HoverModal);
